import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ScopeCtx = createContext(null);

export function ScopeProvider({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const [clients, setClients] = useState([]);
  const [clientId, setClientIdState] = useState(localStorage.getItem("cz_client") || "");
  const [accountId, setAccountIdState] = useState(localStorage.getItem("cz_account") || "");

  const reload = useCallback(async () => {
    if (!user) return;
    const [s, c] = await Promise.all([api.get("/google-ads/status"), api.get("/clients")]);
    setStatus(s.data);
    setClients(c.data);
  }, [user]);

  useEffect(() => { reload().catch(() => {}); }, [reload]);

  const accounts = useMemo(() => {
    const all = status?.accounts || [];
    return clientId ? all.filter((a) => a.client_id === clientId) : all;
  }, [status, clientId]);

  useEffect(() => {
    if (!status) return;
    if (accountId && !accounts.find((a) => a.id === accountId)) setAccountId(accounts[0]?.id || "");
    else if (!accountId && accounts[0]) setAccountId(accounts[0].id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts, status]);

  const setClientId = (v) => { localStorage.setItem("cz_client", v); setClientIdState(v); };
  const setAccountId = (v) => { localStorage.setItem("cz_account", v); setAccountIdState(v); };
  const account = (status?.accounts || []).find((a) => a.id === accountId) || null;

  return (
    <ScopeCtx.Provider value={{ status, clients, clientId, setClientId, accounts, accountId, setAccountId, account, reload }}>
      {children}
    </ScopeCtx.Provider>
  );
}

export const useScope = () => useContext(ScopeCtx);
